import styled from 'styled-components'

export const DiscountWrapper = styled.div`
  margin-bottom: 16px;
  padding: 16px 0;
  border-top: 1px solid ${({ theme }) => theme.colors.border.dark.base};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.dark.base};
`
